<div class="mui-progress-bar__bg" [attr.title]="titleBackground()" role="presentation">
  <div
    class="mui-progress-bar__fill"
    [attr.title]="titleFill()"
    [class.mui-progress-bar__fill--animated]="animated()"
    [class.mui-progress-bar__fill--indeterminate]="indeterminate()"
    [style.transform]="indeterminate() ? null : 'scaleX(' + scaleX() + ')'"></div>
</div>
